import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SUBJECTS } from "@/lib/subjects";

export const Field = ({ label, children, hint }) => (
  <div className="space-y-1.5">
    <Label className="text-sm font-semibold">{label}</Label>
    {children}
    {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
  </div>
);

export const OptionSelect = ({ value, onChange, options, testId, placeholder = "Scegli" }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="h-11 text-base" data-testid={testId}>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent>
      {options.map((o) => {
        const v = typeof o === "string" ? o : o.value;
        const l = typeof o === "string" ? o : o.label;
        return <SelectItem key={v} value={v} data-testid={`${testId}-option-${v}`}>{l}</SelectItem>;
      })}
    </SelectContent>
  </Select>
);

export const SubjectSelect = ({ value, onChange, testId }) => (
  <OptionSelect value={value} onChange={onChange} options={SUBJECTS} testId={testId} placeholder="Materia" />
);
